module.exports = __webpack_public_path__ + "img/m-jizhang.6b71b9b0.svg";